<div class="card text-left h-100">
    <div class="card-header bg-light">
        <h4 class="card-title mb-0">{{ titulo }} Plano de Ação</h4>
    </div>

    <div class="card-body wrapper m-0">
        <form class="needs-validation" novalidate id="myForm" #f="ngForm">
            <div class="row mt-2">

                <div class="col-sm-2">
                    <label for="numeroOsa" class="form-label"><br>Nº Doc. Associado</label>
                    <input type="text" name="numeroOsa" class="form-control form-control-sm" id="numeroOsa" disabled
                        placeholder="-" [value]="model?.osaExecucao?.osa?.numero" />
                </div>
                <div class="col-sm-2">
                    <label for="tipo" class="form-label"><br>Referência</label>
                    <input type="text" name="tipo" class="form-control form-control-sm" id="tipo" disabled
                        placeholder="-" [value]="model?.tipo?.descricao" />
                </div>

                <div class="col-sm-4">
                    <label for="prazoFinal" class="form-label">Prazo Final de <br> Implementação do Plano de
                        Ação</label>
                    <input type="text" name="prazoFinal" class="form-control form-control-sm" id="prazoFinal" disabled
                        placeholder="-" [value]="model.prazoFinal ? (model.prazoFinal | date:'dd/MM/yyyy') : '-'" />
                </div>

                <div class="col-sm-2">
                    <label for="dataFinalizacao" class="form-label"><br>Data de Elaboração do Plano</label>
                    <input type="text" name="dataFinalizacao" class="form-control form-control-sm" id="dataFinalizacao"
                        disabled placeholder="-"
                        [value]="model.dataFinalizacao ? (model.dataFinalizacao | date:'dd/MM/yyyy') : '-'" />
                </div>

                <div class="col-sm-2">
                    <label for="status" class="form-label"><br>Status do Plano de Ação</label>
                    <input type="text" name="status" class="form-control form-control-sm" id="status" disabled
                        placeholder="-" [value]="model?.status?.descricao" />
                </div>

            </div>
            <div class="row mt-2">
                <div class="col-sm-6">
                    <label for="tipoAuditoria" class="form-label">Tipo</label>
                    <input type="text" name="tipoAuditoria" class="form-control form-control-sm" id="tipoAuditoria"
                        disabled placeholder="-"
                        [value]="model?.osaExecucao?.osa?.planejamento?.opa?.tipoAuditoria?.nome" />
                </div>
            </div>

            <div class="row mt-2">
                <div class="col-sm-12">

                    <div class="d-flex align-items-center w-100 mb-2">
                        <label class="form-label mb-0">Ações Cadastradas</label>
                    </div>

                    <div class="mat-elevation-z1">

                        <table mat-table [dataSource]="dataSource" class="w-100" matSort matSortActive="ordem"
                            matSortDirection="asc">

                            <!-- Identificador -->
                            <ng-container matColumnDef="identificador">
                                <th mat-header-cell *matHeaderCellDef mat-sort-header>Identificador</th>
                                <td mat-cell *matCellDef="let element">{{ element.identificador || '' }}</td>
                            </ng-container>

                            <!-- Titulo -->
                            <ng-container matColumnDef="titulo">
                                <th mat-header-cell *matHeaderCellDef mat-sort-header>Ação</th>
                                <td mat-cell *matCellDef="let element">
                                    {{ element.titulo }}
                                </td>
                            </ng-container>

                            <!-- Prazo -->
                            <ng-container matColumnDef="prazo">
                                <th mat-header-cell *matHeaderCellDef mat-sort-header>Prazo de Implementação</th>
                                <td mat-cell *matCellDef="let element">{{ element?.prazo | date: "dd/MM/yyyy" }}</td>
                            </ng-container>

                            <!-- Responsável -->
                            <ng-container matColumnDef="responsavel">
                                <th mat-header-cell *matHeaderCellDef mat-sort-header>Responsável</th>
                                <td mat-cell *matCellDef="let element">{{ element.responsavelNome || '' }}</td>
                            </ng-container>

                            <!-- Status -->
                            <ng-container matColumnDef="status">
                                <th mat-header-cell *matHeaderCellDef mat-sort-header>Status</th>
                                <td mat-cell *matCellDef="let element">
                                    <span *ngIf="element.status.codigo === 1" class="badge bg-gray-dark text-xs">{{
                                        element?.status.descricao }}</span>
                                    <span *ngIf="element.status.codigo === 2" class="badge bg-info text-xs">{{
                                        element?.status.descricao }}</span>
                                    <span *ngIf="element.status.codigo === 3" class="badge bg-warning text-xs">{{
                                        element?.status.descricao }}</span>
                                    <span *ngIf="element.status.codigo === 4" class="badge bg-danger text-xs">{{
                                        element?.status.descricao }}</span>
                                    <span *ngIf="element.status.codigo === 5" class="badge bg-danger text-xs">{{
                                        element?.status.descricao }}</span>
                                    <span *ngIf="element.status.codigo === 6" class="badge bg-success text-xs">{{
                                        element?.status.descricao }}</span>
                                    <span *ngIf="element.status.codigo === 7" class="badge bg-success text-xs">{{
                                        element?.status.descricao }}</span>
                                    <span *ngIf="element.status.codigo === 8" class="badge bg-info text-xs">{{
                                        element?.status.descricao }}</span>
                                    <span *ngIf="element.status.codigo === 9" class="badge bg-primary text-xs">{{
                                        element?.status.descricao }}</span>
                                    <span *ngIf="element.status.codigo === 10"
                                        class="badge bg-atendida-parcialmente text-xs">{{
                                        element?.status.descricao }}</span>
                                    <span *ngIf="element.status.codigo === 11" class="badge bg-warning text-xs">{{
                                        element?.status.descricao }}</span>
                                    <span *ngIf="element.status.codigo === 12" class="badge bg-success text-xs">{{
                                        element?.status.descricao }}</span>
                                    <span *ngIf="element.status.codigo === 13" class="badge bg-gray-dark text-xs">{{
                                        element?.status.descricao }}</span>
                                    <span *ngIf="element.status.codigo === 14" class="badge bg-success text-xs">{{
                                        element?.status.descricao }}</span>
                                </td>
                            </ng-container>

                            <!-- Actions -->
                            <ng-container matColumnDef="actions">
                                <th mat-header-cell *matHeaderCellDef>Ações</th>
                                <td mat-cell *matCellDef="let element">
                                    <div class="d-flex justify-content-center align-items-center">
                                        <button type="button" class="btn btn-primary btn-xs ml-1" title="Preencher"
                                            *ngIf="!visualizar && podePreencher(element)"
                                            (click)="modalAcao('Preencher Ação', false, element)">
                                            <i class="fas fa-pen"></i>
                                        </button>
                                        <button type="button" class="btn btn-info btn-xs ml-1" title="Visualizar"
                                            (click)="modalAcao('Visualizar Ação', true, element)">
                                            <i class="far fas fa-eye"></i>
                                        </button>
                                        <button type="button" class="btn btn-warning btn-xs ml-1" title="Histórico"
                                            (click)="modalHistorico(element)">
                                            <i class="fas fa-history"></i>
                                        </button>
                                    </div>
                                </td>
                            </ng-container>

                            <!-- Header and Row -->
                            <tr mat-header-row
                                *matHeaderRowDef="['identificador', 'titulo', 'prazo', 'responsavel', 'status', 'actions']">
                            </tr>
                            <tr mat-row
                                *matRowDef="let row; columns: ['identificador', 'titulo', 'prazo', 'responsavel', 'status', 'actions']">
                            </tr>

                        </table>

                        <h5 class="table-no-data" [hidden]="dataSource?.data?.length > 0">
                            Nenhuma ação cadastrada
                        </h5>

                        <!-- Paginador -->
                        <mat-paginator [pageSizeOptions]="[15, 30, 50]" showFirstLastButtons></mat-paginator>

                    </div>
                </div>
            </div>
        </form>
    </div>

    <div class="card-footer">
        <div class="d-flex justify-content-between w-100">
            <button type="button" class="btn btn-default btn-sm" (click)="fechar()">
                <i class="fas fa-times"></i> Fechar
            </button>
        </div>
    </div>

</div>